import Report from '../../../model/Report'
import { loadReportList as apiLoadReportList } from '../../../rest-api/Report-api'
import { Dispatch } from 'redux'
import { actionCreatorFactory, AnyAction } from 'typescript-fsa'
import wrapAsyncWorker from '../../../common/wrapAsyncWorker'

const actionCreator = actionCreatorFactory()

export const LoadReportList = actionCreator.async<
  { market: string; reportGroup: string },
  Report[],
  string
>('LoadReportList')

const loadReportListWorker = wrapAsyncWorker(LoadReportList, apiLoadReportList)

// thunk action creator
export const loadReportList = (market: string, reportGroup: string) => 
  (dispatch: Dispatch<AnyAction>) => loadReportListWorker(dispatch, { market, reportGroup })
